// import { gql } from "@apollo/client";
import { gql } from "../../../../__generated__";
// import { SELECTED_PERSON_FRAGMENT } from "./fragments";
export const PEOPLE_PAGE_QUERY = gql(`
query PeoplePage($locationId: UUID, $query: String, $first: Int, $after: String){
  people(locationId: $locationId,query: $query, first: $first, after: $after){
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    edges{
      cursor
      node{
        ...SelectedPerson_Person
      }
    }
    totalCount
  },
  location(id:$locationId) {
    name
    totalStaff
  }
}
`);
